import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,  // 30s global timeout — prevents hanging requests
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("decarboniq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("decarboniq_token");
      localStorage.removeItem("decarboniq_user");
      window.location.href = "/login";
    }
    if (error.response?.status === 402) {
      // Dispatch custom event so any component can show UpgradeModal
      window.dispatchEvent(new CustomEvent("subscription:required", {
        detail: { error: error.response.data }
      }));
    }
    return Promise.reject(error);
  }
);

export default client;
